import React from 'react';
import styled from 'styled-components';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';

interface ContainerProps {
  padding: PaddingProps;
  rounded?: keyof Theme['rounded'];
  gap?: keyof Theme['gap'];
  textSize?: keyof Theme['size'];
  background?: keyof Theme['bg'];
}

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  padding: ${(p) =>
    typeof p.padding === 'object'
      ? `${p.theme.size[p.padding.y]} ${p.theme.size[p.padding.x]}`
      : p.theme.size[p.padding]};
  ${(p) => p.theme.rounded[p.rounded ?? 'md']};
  ${(p) => p.theme.bg[p.background ?? 'point']};
  ${(p) => p.theme.gap[p.gap ?? 'zero']};
  font-size: ${(p) => p.theme.size[p.textSize ?? 'md']};
  color: ${(p) => p.theme.colors.textWhite};
`;

export interface Props extends ContainerProps {
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export default function MessageBox({ icon, children, ...props }: Props) {
  return (
    <Container {...props}>
      {icon}
      {children}
    </Container>
  );
}
